import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Section from '../views/Section.vue'
import Article from '../views/Article.vue'
import TermsAndConditions from '../views/TermsAndConditions.vue'
import PrivacyPolicy from '../views/PrivacyPolicy.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: 'Hardware Pulse - Tech Reviews, News & Gaming Hardware',
      description: 'Stay updated with the latest tech reviews, gaming hardware benchmarks, and industry news at Hardware Pulse.'
    }
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy
  },
  {
    path: '/terms-and-conditions',
    name: 'TermsAndConditions',
    component: TermsAndConditions,
  },
  {
    path: '/article/:slug',
    name: 'ArticleDetail',
    component: Article,
    props: true, // passes slug to Article.vue
    meta: {
      title: 'Article | Hardware Pulse',
      description: 'Read the latest tech reviews and hardware analysis.'
    }
  },
  // New dynamic theme route: e.g. /theme/News, /theme/Reviews, etc.
  {
    path: '/theme/:theme',
    name: 'Theme',
    component: Section,
    props: true, // Section.vue will read route.params.theme
  },
  // 404 route
  {
    path: '/:catchAll(.*)',
    name: 'NotFound',
    component: () => import('../views/NotFound.vue'),
    meta: { 
      statusCode: 404,
      title: '404 - Page Not Found | Hardware Pulse',
      description: 'The page you are looking for could not be found.'
    }
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // If the user is navigating back/forward and there's a saved position, use it
    if (savedPosition) {
      return savedPosition
    }
    // For all other navigation, scroll to top instantly
    return { top: 0 }
  }
})

// Additional global navigation guard to ensure scroll to top
router.beforeEach((to, from, next) => {
  // Continue with navigation
  next()
})

router.afterEach((to, from) => {
  // Ensure scroll to top after navigation completes instantly
  // Use nextTick to wait for DOM updates
  import('vue').then(({ nextTick }) => {
    nextTick(() => {
      window.scrollTo(0, 0)
    })
  })
})

export default router
